import Vue from 'vue'
import draggable  from 'vuedraggable'
Vue.use(draggable)

Vue.component('draggable', draggable)